import { IRootState, RootState } from '../root-state.store';
//@ts-ignore
import { ActivityStatus } from '@/common/enums';
//@ts-ignore
import { IProfileNotificationService, ProfileNotificationService } from '@/services';
import { IProfileNotification } from '../../models/profile-notification';
import { PROFILE_NOTIFICATION_LOADERS } from './profile-notification-types.store';

export interface IProfileNotificationState<TService = any> extends IRootState<IProfileNotificationService> {
  profileNotifications: { section_notification_name: string, section_notification_option: IProfileNotification[] }[];
}
export class ProfileState extends RootState implements IProfileNotificationState<IProfileNotificationService> {
  /**
   *
   */

  profileNotifications:{ section_notification_name: string, section_notification_option: IProfileNotification[] }[]

  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.service = new ProfileNotificationService;
    this.profileNotifications = []
    this.loaders= new Map<string,boolean>([
      [PROFILE_NOTIFICATION_LOADERS.NOTIFICATIONS_DETAILS,false],
      [PROFILE_NOTIFICATION_LOADERS.NOTIFICATIONS_SIDEBAR,false]
    ])
  }
}



// WEBPACK FOOTER //
// ./src/store/profile-notification/profile-notification-state.store.ts